// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q1vc","content":"styles_content__Gm1_5","row":"styles_row__v_dPa","footer":"styles_footer__2QH7g","phraseLength":"styles_phraseLength__2DDRp"};